/**
 * Zod input schemas: hub. Split out of the one big schemas.ts (Oct 2026) so a session opens only the tool it
 * works on; nothing changed in the schemas themselves. Import as before, from '@daaily/shared' (or './schemas.js'
 * inside shared); the barrel re-exports every file in this folder. Shared primitives (EmailSchema, MonthSchema, …)
 * live in primitives.ts; cross-tool references are explicit imports between these files.
 */
import { z } from 'zod';
export const SubmitFeedbackSchema = z.object({
    type: z.enum(['bug', 'improvement']),
    text: z.string().trim().min(1, 'Please describe your feedback').max(5000),
    pageUrl: z.string().trim().max(500).optional(),
    /** Optional screenshot (base64 JPEG, no data: prefix). Capped server-side. */
    screenshotBase64: z.string().optional(),
    screenshotMimeType: z.string().trim().max(120).optional(),
});
export const FeedbackDecideSchema = z
    .object({
    id: z.string().min(1),
    status: z.enum(['open', 'on_hold', 'completed', 'rejected']),
    reason: z.string().trim().max(2000).optional(),
})
    .superRefine((data, ctx) => {
    if (data.status === 'rejected' && !data.reason) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['reason'],
            message: 'A reason is required when rejecting feedback',
        });
    }
});
export const DismissAnnouncementSchema = z.object({
    key: z.string().trim().min(1).max(120),
});
/** Home "Needs your attention": hide one to-do there (or undo). */
export const HubAcknowledgeTodoSchema = z.object({
    id: z.string().trim().min(1).max(200),
    /** The label shown — the item comes back when it changes. */
    label: z.string().trim().min(1).max(400),
    undo: z.boolean().optional(),
});
/** Performance reviews: mark one guidance screen as seen (key from `reviewGuidanceSeenKey`). */
export const ReviewMarkGuidanceSeenSchema = z.object({
    key: z.string().trim().min(1).max(120),
});
//# sourceMappingURL=hub.js.map